// import { useMediaQuery, useTheme } from '@mui/material';
import { YouTubePlayer } from 'react-youtube';
import { isMobileOnly } from 'react-device-detect';
import { Logger } from '../../../../config/logging/logger';

export function useYoutubeMobileFullScreen() {
  const logger = Logger.create('useYoutubeMobileFullScreen');
  // isMobileOnly will exclude Tablet
  // Cannot use theme MD because requesting full screen will cause
  // The app to re-render in desktop due to window width changes.
  const requestFullScreen = async (youtube: YouTubePlayer) => {
    if (isMobileOnly) {
      const youtubeIframe = await youtube.getIframe();
      if (!youtubeIframe) {
        logger.error(Logger.format('Player is not ready yet.'));
        return;
      }
      logger.debug(Logger.format('youtubeIframe.requestFullscreen'));
      // Request fullscreen on the iframe
      if (youtubeIframe.requestFullscreen) {
        youtubeIframe.requestFullscreen();
      }
    }
  };
  return {
    requestFullScreen,
  };
}
